import script from "./TagPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./TagPage.vue?vue&type=script&lang=ts&setup=true"

import "./TagPage.vue?vue&type=style&index=0&id=d02aa720&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d02aa720"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator});
